import React, { useEffect, useRef, useState } from "react";

import SoftProfile from "../../../components/ProfilePictures/SoftProfile";

import PhotoCameraOutlinedIcon from "@mui/icons-material/PhotoCameraOutlined";
import DeleteOutlineOutlinedIcon from "@mui/icons-material/DeleteOutlineOutlined";

import { GET_IMAGE } from "../../../helpers/images";

const ProfilePicture = ({
  fileSelectedCallback,
  disabled = false,
  userDetails
}) => {
  const [imageURL, setImageURL] = useState(null);
  const fileRef = useRef();

  useEffect(() => {
    if (userDetails?.image) {
      const imgURL = GET_IMAGE(userDetails?.image);
      setImageURL(imgURL);
    }
  }, [userDetails]);

  useEffect(() => {
    // Cleanup
    return () => {
      URL.revokeObjectURL(imageURL);
    }
  }, [imageURL]);

  const setSelectedFile = async (e) => {
    const pictureBlob = URL.createObjectURL(e.target.files[0]);

    setImageURL(pictureBlob);
    fileSelectedCallback?.(e.target.files[0]);
  }

  const clearFile = (e) => {
    e.preventDefault();

    URL.revokeObjectURL(imageURL);
    setImageURL(null);
    fileRef.current.value = null;

    fileSelectedCallback?.(null, true);
  }

  const fullName = [userDetails?.firstName, userDetails?.lastName].filter(Boolean).join(" ") || "User";

  return (
    <div className="rounded-2xl border border-gray-200 bg-white p-4 sm:p-6 mb-2.5 sm:mb-3 shadow-sm flex items-center justify-between gap-3">
      <div className="flex items-center gap-3 min-w-0">
        <SoftProfile
          src={imageURL}
          name={userDetails?.firstName}
          size="lg"
          fullCover
          sx={{ height: "48px", width: "48px", flexShrink: 0 }}
        />
        <div className="min-w-0">
          <p className="text-[15px] font-bold text-gray-900 truncate m-0">{fullName}</p>
          <p className="text-xs text-gray-400 m-0">PNG or JPEG, under 10mb</p>
        </div>
      </div>

      <div className="flex items-center gap-2 flex-shrink-0">
        <button
          type="button"
          aria-label="Change profile picture"
          disabled={disabled}
          onClick={() => fileRef.current.click()}
          className="w-9 h-9 rounded-full border border-gray-200 flex items-center justify-center text-gray-500 hover:bg-gray-50 disabled:opacity-50"
        >
          <PhotoCameraOutlinedIcon sx={{ fontSize: 18 }} />
        </button>

        <input
          type="file"
          hidden
          ref={fileRef}
          accept="image/png, image/jpeg"
          name="fileforupload"
          onChange={setSelectedFile}
        />

        <button
          type="button"
          aria-label="Delete profile picture"
          disabled={disabled}
          onClick={clearFile}
          className="w-9 h-9 rounded-full border border-gray-200 flex items-center justify-center text-gray-500 hover:bg-red-50 hover:text-red-500 disabled:opacity-50"
        >
          <DeleteOutlineOutlinedIcon sx={{ fontSize: 18 }} />
        </button>
      </div>
    </div>
  );
};

export default ProfilePicture;
